import { WORK_ORDERS_URL } from '~/app_constants';
import { mapInertiaProps } from '~/utils/inertia';
import { applyTemplate } from '~/utils/url_template';

export default {
  computed: {
    ...mapInertiaProps({
      organizationId: (page) => page.organization.id,
    }),
  },
  methods: {
    workOrdersUrl(woId) {
      return applyTemplate(WORK_ORDERS_URL, {
        woId,
        organizationId: this.organization.id,
      });
    },
    async confirmSoftDeleteWorkOrder(workOrder) {
      if (confirm("Are you sure you want to delete this work order?\nYou won't be able to access any of its data")) {
        this.$inertia.delete(this.workOrdersUrl(workOrder.id));
      }
    },
    confirmArchiveWorkOrder(workOrder) {
      if (confirm('Are you sure you want to close this work order?')) {
        this.$inertia.patch(`${this.workOrdersUrl(workOrder.id)}/archive`);
      }
    },
    async confirmRestoreWorkOrder(workOrder) {
      if (confirm('Are you sure you want to reopen this work order?')) {
        this.$inertia.patch(`${this.workOrdersUrl(workOrder.id)}/restore`);
      }
    },
  },
};
